<template>
  <div
    class="datos"
    @dblclick="
      //ExportConfigurable(aplicacion);
      Imagen(aplicacion)
    "
  >
    DATOS
  </div>
</template>

<script>
import XLSX from "xlsx";

export default {
  name: "Datos",
  props: {
    aplicacion: Object,
  },
  data() {
    return {
      extension: "webp",
      separador: "&",
      separador2: "-",
    };
  },
  methods: {
    ExportConfigurable(aplicacion) {
      var exportacion;
      var workbook = XLSX.utils.book_new();
      var sheet;
      var acabados = [];
      var formulaImagen;
      var nImagenes;
      var capa;

      function NImagenes(coleccion, campo) {
        var ret = 1;

        if (coleccion.toUpperCase() == "QUITO") {
          if (campo == "POMO_ST") {
            ret = 2;
          }
        }

        return ret;
      }

      // Recorre el objeto aplicacion
      aplicacion.colecciones.forEach((coleccion) => {
        exportacion = [];
        // Crea cada fila de la excel
        coleccion.sides[0].grupos.forEach((grupo) => {
          grupo.campos.forEach((campo) => {
            // Campos cuya imagen está compuesta con otro campo
            if (campo.compuesto != undefined) {
              // HARDCODE 3: Imágenes dobles
              nImagenes = NImagenes(coleccion.cod, campo.cod);
              // HARDCODE 3: Imágenes dobles
              for (let nImagen = 1; nImagen <= nImagenes; nImagen++) {
                if (nImagenes > 1) {
                  capa = nImagen;
                } else {
                  capa = "";
                }
                for (let i = 0; i < campo.acabados.length; i++) {
                  aplicacion.perfil[campo.cod.toLowerCase()].value =
                    campo.acabados[i].cod;
                  acabados = campo.compuesto.GetAcabadosValidos(
                    aplicacion.perfil
                  );
                  for (let j = 0; j < acabados.length; j++) {
                    exportacion.push([
                      coleccion.cod.toUpperCase(),
                      grupo.cod,
                      campo.visual ? "SI" : "NO",
                      campo.cod + "-" + campo.compuesto.cod,
                      campo.acabados[i].cod + "-" + acabados[j].cod,
                      campo.acabados[i].GetLiteral("es") +
                        "-" +
                        acabados[j].GetLiteral("es"),
                      capa,
                      "",
                    ]);
                  }
                }
              }
            } else {
              if (campo.acabados.length > 0) {
                for (let i = 0; i < campo.acabados.length; i++) {
                  //exportacion.push([coleccion.cod.toUpperCase(), grupo.cod, campo.visual ? "SI" : "NO", campo.cod, campo.acabados[i].cod, campo.acabados[i].GetLiteral("es"), "", ""]);
                  if (campo.acabados[i].compuesto == null) {
                    exportacion.push([
                      coleccion.cod.toUpperCase(),
                      grupo.cod,
                      campo.visual ? "SI" : "NO",
                      campo.cod,
                      campo.acabados[i].cod,
                      campo.acabados[i].GetLiteral("es"),
                      "",
                      "",
                    ]);
                  } else {
                    for (
                      let j = 0;
                      j < campo.acabados[i].compuesto.acabados.length;
                      j++
                    ) {
                      exportacion.push([
                        coleccion.cod.toUpperCase(),
                        grupo.cod,
                        campo.visual ? "SI" : "NO",
                        campo.cod + "-" + campo.acabados[i].compuesto.cod,
                        campo.acabados[i].cod +
                          "-" +
                          campo.acabados[i].compuesto.acabados[j].cod,
                        campo.acabados[i].GetLiteral("es") +
                          "-" +
                          campo.acabados[i].compuesto.acabados[j].GetLiteral(
                            "es"
                          ),
                        "",
                        "",
                      ]);
                    }
                  }
                }
              } else {
                exportacion.push([
                  coleccion.cod.toUpperCase(),
                  grupo.cod,
                  campo.visual ? "SI" : "NO",
                  campo.cod,
                  "",
                  "",
                  "",
                  "",
                ]);
              }
            }
          });
        });
        // Ordenas las filas con las que se crea la excel
        exportacion = exportacion.sort(function (a, b) {
          // Ordenar por visual='SI' (primero los 'SI', luego los 'NO' o nulos)
          if (a[2] === "SI" && b[2] !== "SI") return -1;
          if (a[2] !== "SI" && b[2] === "SI") return 1;
          // Ordenar por acabado != nulo (primero los que tienen acabado, luego los nulos)
          if (a[4] !== "" && b[4] === "") return -1;
          if (a[4] === "" && b[4] !== "") return 1;
          // Ordenar por tipo,
          if (a[1] < b[1]) return -1;
          if (a[1] > b[1]) return 1;
          // luego por campo,
          if (a[3] < b[3]) return -1;
          if (a[3] > b[3]) return 1;
          // y por acabado
          if (a[4] < b[4]) return -1;
          if (a[4] > b[4]) return 1;
          // Si ninguno de los casos anteriores aplica, mantener el orden actual
          return 0;
        });

        // Añade las formulas de la imagen (una vez ya está ordenado, esto es  por el índice de la formula: A1, A2, etc.)
        for (let i = 0; i < exportacion.length; i++) {
          if (exportacion[i][2] == "SI") {
            formulaImagen =
              "CONCATENATE(A" +
              (i + 2) +
              ',"' +
              this.separador +
              '",B' +
              (i + 2) +
              ',"' +
              this.separador +
              '",D' +
              (i + 2) +
              ',"' +
              this.separador +
              '",E' +
              (i + 2) +
              "," +
              "IF(G" +
              (i + 2) +
              '="","",' +
              'CONCATENATE("' +
              this.separador +
              '",' +
              "G" +
              (i + 2) +
              "))" +
              ',".' +
              this.extension +
              '")';

            exportacion[i][7] = { v: "", t: "s", f: formulaImagen };
          }
        }
        // Añade los títulos de las columnas
        exportacion.unshift([
          "coleccion",
          "tipo",
          "visual",
          "caracteristica",
          "valor",
          "texto",
          "capa",
          "imagen",
        ]);

        // Genera la hoja y la añade a la excel
        sheet = XLSX.utils.aoa_to_sheet(exportacion);
        XLSX.utils.book_append_sheet(workbook, sheet, coleccion.cod);
        console.log(exportacion);
      });

      //Exporta la excel
      let now = new Date();
      if (aplicacion.colecciones.length > 1) {
        XLSX.writeFile(
          workbook,
          "configurable " +
            now.getFullYear() +
            "_" +
            (now.getMonth() + 1) +
            "_" +
            now.getDate() +
            "_" +
            now.getHours() +
            "_" +
            now.getMinutes() +
            "_" +
            now.getSeconds() +
            ".xlsx"
        );
      } else {
        XLSX.writeFile(
          workbook,
          aplicacion.colecciones[0].cod +
            " configurable " +
            now.getFullYear() +
            "_" +
            (now.getMonth() + 1) +
            "_" +
            now.getDate() +
            "_" +
            now.getHours() +
            "_" +
            now.getMinutes() +
            "_" +
            now.getSeconds() +
            ".xlsx"
        );
      }
    },
    ExportTacos(aplicacion) {
      var exportacion;
      var workbook = XLSX.utils.book_new();
      var sheet;
      var formulaImagen;

      // Recorre el objeto aplicacion
      aplicacion.colecciones.forEach((coleccion) => {
        exportacion = [];
        // Crea cada fila de la excel
        coleccion.sides[0].grupos.forEach((grupo) => {
          grupo.campos.forEach((campo) => {
            if (campo.acabados.length > 0 && campo.visual) {
              for (let i = 0; i < campo.acabados.length; i++) {
                exportacion.push([
                  coleccion.cod.toUpperCase(),
                  campo.cod,
                  campo.acabados[i].cod,
                  campo.acabados[i].GetLiteral("es"),
                  "",
                ]);
              }
            }
          });
        });

        // Añade las formulas de la imagen (una vez ya está ordenado, esto es  por el índice de la formula: A1, A2, etc.)
        for (let i = 0; i < exportacion.length; i++) {
          formulaImagen =
            "CONCATENATE(B" +
            (i + 2) +
            ',"' +
            this.separador +
            '",C' +
            (i + 2) +
            ',".' +
            this.extension +
            '")';
          exportacion[i][4] = { v: "", t: "s", f: formulaImagen };
        }
        // Añade los títulos de las columnas
        exportacion.unshift([
          "coleccion",
          "caracteristica",
          "valor",
          "texto",
          "taco",
        ]);

        // Genera la hoja y la añade a la excel
        sheet = XLSX.utils.aoa_to_sheet(exportacion);
        XLSX.utils.book_append_sheet(workbook, sheet, coleccion.cod);
        console.log(exportacion);
      });

      //Exporta la excel
      let now = new Date();
      if (aplicacion.colecciones.length > 1) {
        XLSX.writeFile(
          workbook,
          "tacos " +
            now.getFullYear() +
            "_" +
            (now.getMonth() + 1) +
            "_" +
            now.getDate() +
            "_" +
            now.getHours() +
            "_" +
            now.getMinutes() +
            "_" +
            now.getSeconds() +
            ".xlsx"
        );
      } else {
        XLSX.writeFile(
          workbook,
          aplicacion.colecciones[0].cod +
            " tacos " +
            now.getFullYear() +
            "_" +
            (now.getMonth() + 1) +
            "_" +
            now.getDate() +
            "_" +
            now.getHours() +
            "_" +
            now.getMinutes() +
            "_" +
            now.getSeconds() +
            ".xlsx"
        );
      }
    },
    Imagen(aplicacion) {
      var coleccion = aplicacion.colecciones[0];
      var archivo;
      var imagenes = new Set();

      imagenes.add(
        coleccion.cod.toUpperCase() + this.separador + "FONDO." + this.extension
      );
      coleccion.sides[0].grupos.forEach((grupo) => {
        grupo.campos.forEach((campo) => {
          if (campo.visual) {
            // Si el campo es compuesto la capa se forma con los códigos del campo y el campo compuesto
            if (campo.compuesto != undefined) {
              archivo =
                coleccion.cod.toUpperCase() +
                this.separador +
                grupo.cod +
                this.separador +
                campo.cod +
                this.separador2 +
                campo.compuesto.cod +
                this.separador +
                campo.acabadoSel.cod +
                this.separador2 +
                campo.compuesto.acabadoSel.cod +
                "." +
                this.extension;
            } else {
              if (campo.acabadoSel.compuesto == null) {
                archivo = campo.acabadoSel.capa;
              } else {
                archivo =
                  coleccion.cod.toUpperCase() +
                  this.separador +
                  grupo.cod +
                  this.separador +
                  campo.cod +
                  this.separador2 +
                  campo.acabadoSel.compuesto.cod +
                  this.separador +
                  campo.acabadoSel.cod +
                  this.separador2 +
                  campo.acabadoSel.compuesto.acabadoSel.cod +
                  "." +
                  this.extension;
              }
            }
            imagenes.add(archivo);
          }
        });
      });
      // Limpia las capas que no deben aparecer porque el acabado ya se muestra en un compuesto
      coleccion.sides[0].grupos.forEach((grupo) => {
        grupo.campos.forEach((campo) => {
          if (campo.visual) {
            // Calcula la capa que sobra
            if (campo.compuesto == undefined) {
              if (campo.acabadoSel.compuesto != null) {
                imagenes.delete(campo.acabadoSel.compuesto.acabadoSel.capa);
              }
            }
          }
        });
      });

      console.log(imagenes);
    },
  },
};
</script>

<style lang="scss" scoped>
.datos {
  background-color: black;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  z-index: 99999;
  left: 0;
  top: $Header-height;
  width: 100px;
  height: 100px;
}
</style>
